import { useCallback } from "react";
import { useNavigate } from "react-router";

import { APP_URL, getAppUrl } from "utils/defines";
import { useAuth } from "utils/hooks/useAuth";
import useTranslation from "utils/hooks/useTranslation";

import { NavigationLayout } from "components/Navigation/NavigationLayout";
import { SvgAddressBook, SvgSquareBolt, SvgUser_outline, SvgExit, SvgArrow } from "components/svg";

import { ProfilePage } from "./ProfilePage";
import { ClientsPage } from "./ClientsPage";
import { TarifPopup } from "components/popups/TarifPopup";
import { usePopup } from "providers/PopupProvider";


export const AccountPage: React.FC = () => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { openPopup, closeLastPopup } = usePopup();

  const navigationItems = [
    { key:'index', url: APP_URL.Account, icon: <SvgUser_outline />, title: t("ACCOUNT_PERSONAL_INFO"), component: <ProfilePage />, showTitle: true, showTitleMobile: true },
    { key:'clients', url: APP_URL.Clients, icon: <SvgAddressBook />, title: t("ACCOUNT_MY_CUSTOMERS"), component: <ClientsPage />, showTitle: true, showTitleMobile: true },
    { key:'tarifs', url: "", icon: <SvgSquareBolt />, secondIcon: <SvgArrow />, title: t("ENERGY_PRICE"), component: <ProfilePage />, showTitle: true, showTitleMobile: true },
    { key:'sep', separator: true},
    { key:'disconnect', url: "", icon: <SvgExit />, title: t("MMENU_LOGOUT"), component: <ProfilePage />, showTitle: true, showTitleMobile: true },
  ];

  const handleItemClick = useCallback((item: any) => {
    switch (item.key) {
      case "tarifs":
        openPopup(
          <TarifPopup
            closePopup={closeLastPopup}
          ></TarifPopup>
        )
        break;
      case "disconnect":
        logout();
        break;

        default:
          navigate(getAppUrl(item.url));
          break;
    }
  }, [logout, navigate, getAppUrl]);

  const isAccountItemSelected = (item: any, currentPage: string) => {
    return item.key === currentPage;
  };

  return (
    <NavigationLayout
      defaultPage="clients"
      items={navigationItems}
      onItemClick={handleItemClick}
      isSelected={isAccountItemSelected}
      isMonCompte={true}
    />
  );
};






// import { Page } from "components/Page";
// import Ripple from "components/Ripple";
// import { useLocation, useNavigate, useParams } from "react-router";
// import { useCallback, useEffect, useState } from "react";
// //import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
// import { APP_URL, getAppUrl } from "../../utils/defines";
// import { SvgAddressBook, SvgSquareBolt, SvgUser_outline, SvgExit } from "components/svg";
// import { ProfilePage } from "./ProfilePage";
// import { ClientsPage } from "./ClientsPage";
// import useTranslation from "utils/hooks/useTranslation";
// import { useAuth } from "utils/hooks/useAuth";
// import NewProjectWidget from "components/NewProjectWidget";

// export const AccountPage: React.FC = () => {
//   const { section  } = useParams();
//   const location = useLocation();  
//   const { t, tText } = useTranslation();
//   //const { network } = useSalesNetwork();
//   const navigate = useNavigate();
//   const [ currentPage, setCurrentPage ] = useState('index');
//   const { logout } = useAuth();

//   const navigationItems = [
//     { key:'index', url: APP_URL.Account, icon: <SvgUser_outline />, title: "Mes info personnelles", selected: currentPage === 'index', component: <ProfilePage />, showTitle: true },
//     { key:'clients', url: APP_URL.Clients, icon: <SvgAddressBook />, title: "Mes clients", selected: currentPage === 'clients', component: <ClientsPage />, showTitle: true },
//     { key:'tarifs', url: "", icon: <SvgSquareBolt />, title: t("ENERGY_PRICE"), selected: currentPage === 'tarifs', component: <ProfilePage />, showTitle: true },
//     { key:'sep', url: "", icon: <></>, title: "", selected: false, component: <></>, showTitle: false },
//     { key:'disconnect', url: "", icon: <SvgExit />, title: t("MMENU_LOGOUT"), selected: currentPage === 'satisfaction', component: <ProfilePage />, showTitle: true },
//   ];

//   const onNavigationClick = useCallback((item: any) => {
//       setCurrentPage(item?.key)
//       switch (item?.key){
//         case "tarifs":
//           alert('tarifs')
//           break;
//         case "disconnect":
//           logout();
//           break;

//         default:
//           navigate(getAppUrl(item.url));
//           break;
//       }
//   }, [])

//   useEffect(() => {
//     if (location.pathname.endsWith("/satisfaction")) {
//       setCurrentPage('satisfaction');
//     } else {
//       setCurrentPage(section ?? 'index');
//     }
//   },[section])

//   const currentItem = navigationItems.filter((i)=>i.key === currentPage)[0];

//   //console.log(currentItem)

//   return (
//     <group data-direction="column" data-align="center" data-height="autofit">
//       <group data-wrap="no" data-height="fit" data-max-length="1200">
//         <group data-space="20" data-gap="20" data-direction="column" data-fit="1" data-max-length="350">
//             <group data-wrap="no" data-space="20" data-gap="10" data-direction="column" data-background="white" data-border="" data-radius="15" className="group-fixed-top">
//               {
//                 navigationItems.map((item: any) => {
//                   return (
//                     item.key === 'sep' ?
//                     <separator data-horizontal=""></separator>
//                     :
//                     <group 
//                       key={item?.key}
//                       data-contain="" 
//                       data-shrink="no"
//                       data-name="autoseparation"
//                       data-wrap="no"
//                       data-align="center"
//                       data-width="autofit">
//                       <separator data-vertical="" data-height="20"></separator>
//                       {/* <Ripple> */}
//                         <group 
//                           data-height="fit" 
//                           data-width="autofit" 
//                           data-interactive="" 
//                           data-cursor="pointer" 
//                           data-align="center" 
//                           data-space="5" 
//                           data-space-horizontal="15" 
//                           data-gap="5" 
//                           data-wrap="no" 
//                           data-radius="5" 
//                           data-contain=""
//                           onClick={()=>onNavigationClick(item)}
//                          {...(item.selected ? {"data-background1":"main", "data-color":"main"} : {})}
                         
//                          >
//                           <icon data-svg-size="16" data-svg-color="main">{item?.icon}</icon>
//                           <text>{item?.title}</text>
//                         </group>
//                       {/* </Ripple> */}

//                      </group>
//                   )
//                 })
//               }

//             </group>
            
//             <NewProjectWidget />
//         </group>
//         <group 
//           data-space="20" data-gap="20" data-fit="2" data-direction="column" data-wrap="no"
//           //style={{ backgroundColor: "yellow" }}
//         >
//           {currentItem?.showTitle && <group data-wrap="no" data-space-top="20" data-gap="20" data-max-length="1440">
//             <group data-height="fit" data-length="5" data-background="main"></group>
//             <group data-length="autofit">
//               <text data-color="main" data-text-size="40">{currentItem?.title}</text>
//             </group>
//           </group>}
//           <group >
//               {
//                 currentItem?.component
//               }
//           </group>
//         </group>
//       </group>
//     </group>
//   );
// };
